import Radium from "radium";
import React from "react";
import moment from "moment";

import { remoStyles } from "@common/styles";
import { Input, TextArea } from "@components";
import { IApiKey } from "@common/models";

export interface IEditApiKeyProps {
  apiKey: IApiKey;
  closeModal: () => void;
  updateApiKey: (tokenName: string, expireDate: string) => void;
  deleteApiKey: () => void;
}

export interface IEditApiKeyState {
  tokenName: string;
  expireDate: string;
}

class EditApiKey extends React.Component<IEditApiKeyProps, IEditApiKeyState> {
  constructor(props) {
    super(props);
    this.state = {
      tokenName: "",
      expireDate: ""
    };
  }

  public render() {
    const remoCancelButtonStyle = {
      ...remoStyles.okButton,
      backgroundColor: "#444"
    };
    const remoDeleteButtonStyle = {
      ...remoStyles.okButton,
      backgroundColor: "#7a1317"
    };

    const { apiKey } = this.props;
    const { expireDate, tokenName } = this.state;
    const userHasApiKeys = !!apiKey;
    const remoContentStyle = { ...remoStyles.text, flexDirection: "column" };
    const remoHeaderStyle = { ...remoStyles.header, marginBottom: "10px" };
    const oldExpDate = moment(apiKey.expireDate);
    const oldExpDateString = oldExpDate.format();

    return (
      <div style={remoStyles.container as any}>
        <div style={remoHeaderStyle as any}>
          {userHasApiKeys ? "Rediger API-nøkkel" : "Opprett API-nøkkel"}
        </div>
        <div style={remoContentStyle as any}>
          {userHasApiKeys ? (
            <div style={{ flexDirection: "column" }}>
              <div style={remoStyles.field as any}>
                <div style={remoStyles.label as any}>Nåværende navn</div>
                <div>{apiKey.tokenName}</div>
              </div>
              <div style={remoStyles.input}>
                <Input
                  name="apiKeyNewName"
                  label="Nytt navn"
                  value={tokenName}
                  type="text"
                  onChange={tokenName => this.setState({ tokenName })}
                />
              </div>
              <div style={remoStyles.field as any}>
                <div style={remoStyles.label as any}>Nåværende utløpsdato</div>
                <div>{oldExpDateString}</div>
              </div>
              <div style={remoStyles.input}>
                <Input
                  name="apiKeyNewDate"
                  label="Ny utløpsdato (åååå-mm-dd)"
                  value={expireDate}
                  type="text"
                  onChange={expireDate => this.setState({ expireDate })}
                />
              </div>
              <div>
                <TextArea readOnly label="Token" value={apiKey.accessToken} />
              </div>
            </div>
          ) : null}
        </div>
        <div
          style={remoStyles.okButton as any}
          onClick={() =>
            this.props.updateApiKey(this.state.tokenName, this.state.expireDate)
          }
        >
          Lagre
        </div>
        {userHasApiKeys ? (
          <div
            style={remoDeleteButtonStyle as any}
            onClick={this.props.deleteApiKey}
          >
            Slett API-nøkkel
          </div>
        ) : null}
        <div
          style={remoCancelButtonStyle as any}
          onClick={this.props.closeModal}
        >
          Avbryt
        </div>
      </div>
    );
  }
}

export default Radium(EditApiKey);
